import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStartEvaluation = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.14464 0.70162C1.08468 0.67235 1.01729 0.661825 0.951261 0.671418C0.885232 0.681011 0.823625 0.710276 0.774473 0.755397C0.725322 0.800519 0.690906 0.859403 0.675713 0.924373C0.660521 0.989342 0.665256 1.05738 0.689303 1.11962L2.58464 6.20429C2.69642 6.50444 2.69642 6.8348 2.58464 7.13495L0.68997 12.2196C0.666044 12.2818 0.661371 12.3497 0.676555 12.4146C0.69174 12.4794 0.726081 12.5382 0.775116 12.5833C0.82415 12.6284 0.885611 12.6576 0.95151 12.6673C1.01741 12.677 1.0847 12.6667 1.14464 12.6376L13.1446 6.97095C13.2017 6.94396 13.25 6.9013 13.2837 6.84796C13.3175 6.79461 13.3355 6.73276 13.3355 6.66962C13.3355 6.60648 13.3175 6.54463 13.2837 6.49128C13.25 6.43794 13.2017 6.39528 13.1446 6.36829L1.14464 0.70162Z",
		stroke: "white",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgStartEvaluation);
export default ForwardRef;
